const DurationDays = [
  {
    Value: 1,
    Label: "1 día",
    Days: 1
  },
  {
    Value: 2,
    Label: "2 días",
    Days: 2
  },
  {
    Value: 3,
    Label: "3 días",
    Days: 3
  },
  {
    Value: 4,
    Label: "4 días",
    Days: 4
  },
  {
    Value: 5,
    Label: "5 días",
    Days: 5
  }
];

const DurationHours = [
  {
    Value: 1,
    Label: "1 Hora",
    Hours: 1
  },
  {
    Value: 2,
    Label: "2 Horas",
    Hours: 2
  },
  {
    Value: 3,
    Label: "3 Horas",
    Hours: 3
  },
  {
    Value: 4,
    Label: "4 Horas",
    Hours: 4
  },
  {
    Value: 5,
    Label: "5 Horas",
    Hours: 5
  },
  {
    Value: 6,
    Label: "6 Horas",
    Hours: 6
  },
  {
    Value: 7,
    Label: "7 Horas",
    Hours: 7
  }
];
export { DurationDays, DurationHours };
